import React, { useState, useEffect } from "react";
import { getUser, PHP_API } from "../../utils/Common";
import axios from "axios";
import VainillaDialog from "./vanilladialog";

const HistorialEstados = (props) => {
    const data = props.data ?? [];
    const [edicion, setedicion] = useState(null);
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });

    const formatearFecha = (fechaStr) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const fecha = new Date(fechaStr);
        const hora = fecha.toLocaleTimeString();

        return `${fecha.toLocaleDateString(undefined, options)} ${hora}`;
    }

    const submit = (event) => {
        event.preventDefault();
        let data = { charolas: edicion.monto, germinacion: edicion.germinacion, user: getUser().id, id: edicion.historial_id };
        console.log(data);
        setloader(true);
        axios
            .post(PHP_API + "HistorialEstatusvivero_actualizar", data)
            .then((r) => {

                console.log(r.data && r.data.estatus);
                if (r.data && r.data.estatus) {
                    window.location.reload();
                    return;
                }
                else setloader(false);
                setdialog({
                    show: true,
                    tipo: 'error',
                    title: "Ocurrió un error",
                    body: r.data && r.data.msj ? r.data.msj : "Ocurrió un problema de comunicación al realizar los ajustes",
                    size: 'm',
                    funct: (resp) => { setdialog({ show: false }) }
                });

            })
            .catch((e) => {
                setloader(false);
                setdialog({
                    show: true,
                    tipo: 'error',
                    title: "Ocurrió un error",
                    body: "Ocurrió un problema de comunicación al realizar los ajustes",
                    size: 'm',
                    funct: (resp) => { setdialog({ show: false }) }
                });
            });



    }

    const change = (event) => {
        let e = { ...edicion };
        e[event.target.name] = +event.target.value;
        setedicion(e);
    }

    return (
        <div className="vw-100 vh-100 blur-l bg-white4 overflow m-0 p-2 " style={{ position: "fixed", top: 0, left: 0, zIndex: 99 }}>
            <div className='row justify-content-center p-0 m-0 w-100 mt-5'>
                <div className='col-lg-10'>
                    <div className='row justify-content-center p-3 bg-white rounded shadow'>
                        {!edicion && <div className='col-lg-12 text-center mb-4' style={{ position: 'sticky', top: '0' }}>
                            <button className='btn btn-dark shadow' onClick={() => { props.cerrar() }}>Volver</button>
                        </div>}
                        {!edicion && <div className='col-lg-12 m-0 p-0 overflow '>
                            <table className='table table-sm tex-center'>
                                <thead>
                                    <tr className="nowrap" >
                                        {data && data.length > 0 && data[0].reporte && <th className="text-center">Tipo de reporte</th>}
                                        <th className="text-center">Fecha</th>
                                        <th className="text-center">Usuario</th>
                                        <th className="text-center">Charolas registradas</th>
                                        <th className="text-center">Germinacion</th>
                                        <th className="text-center">plantas</th>
                                        <th className="text-center">total plantas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data.map((d, i) => {
                                            return d.completo !== 1 ? (
                                                <tr key={"history3" + i} className="scale-025 pointer nowrap" onClick={() => {
                                                    if (edicion) return; setedicion(d); console.log(d);
                                                }} >
                                                    {d.reporte && <td className="text-center text-bold pointer" key={'hito ' + i}  >{d.reporte}</td>}
                                                    <td className="text-center">{formatearFecha(d.fecha)}</td>
                                                    <td className="text-center">{d.usuario}</td>
                                                    <td className="text-center">{d.monto}</td>
                                                    <td className="text-center">{d.germinacion}%</td>
                                                    <td className="text-center">{d.plantas}</td>
                                                    <td className="text-center">{d.acumulado}</td>
                                                </tr>
                                            ) : (
                                                <tr key={"history3" + i} >
                                                    {d.reporte && <td className="text-center text-bold" key={'hito ' + i}>{d.reporte}</td>}
                                                    <td colSpan={1} className="text-center  text-green4" key={'hito ' + i}>{formatearFecha(d.fecha)}</td>
                                                    <td colSpan={1} className="text-center text-bold">{d.usuario}</td>
                                                    <td colSpan={d.reporte ? 5 : 4} className="text-center text-success text-bold">REGISTRO MARCADO COMO CONCLUIDO</td>
                                                </tr>
                                            )
                                        })
                                    }


                                </tbody>
                            </table>

                        </div>}
                        {edicion && <>
                            <form className="w-100 text-center relative" onSubmit={submit}>
                                <div className='row justify-content-evenly'>
                                    <div className='form-group col-md-6 m-2'>
                                        <label className='text-bold'>Ajustar Germinación</label>
                                        <input type='number' step={0.0001} min={0} max={1} className='form-control shadow border' name="germinacion" onChange={change} value={edicion.germinacion} />

                                    </div>

                                    <div className='form-group col-md-6 m-2'>
                                        <label className='text-bold'>Ajustar charolas</label>
                                        <input type='number' step={0.0001} min={1} name="monto" className='form-control shadow border' onChange={change} value={edicion.monto} />

                                    </div>
                                    <div className='col-lg-12 mb-4'></div>
                                    <button className='btn btn-light shadow wpx-300 mb-3 border border-danger' type="submit" >Actualizar</button>
                                    <button className='btn btn-light shadow wpx-300 mb-3 border' type="button" onClick={() => { setedicion(null) }}>Regresar</button>
                                </div>
                                {loader && <div className='w-100 h-100 blur-m m-0 p-0' style={{ position: 'absolute', left: 0, top: 0, zIndex: 3 }}><div className='loader-local'></div></div>}
                            </form>

                        </>}
                    </div>

                </div>
            </div>
            <VainillaDialog data={dialog} />
        </div>
    )
}
export default HistorialEstados;